import { Task } from 'packages/lib/api/annotations/contract/task';
// May-20-2026 Used Cursor (Auto / Claude Opus 4.7 / Sonnet 4.6) to detect single-task SE schema

/** Minimum fields from Task required to determine if Scene Enrichment is in single-task mode */
type SingleTaskModeCheckable = {
  type: Task['type'] | null;
  imageExtractionToken: Task['imageExtractionToken'];
};

/**
 * Is Scene Enrichment running in the new single-task mode, where all images come
 * from a single task (imageExtractionToken), instead of a task per image?
 */
export const isSceneEnrichmentInSingleTaskMode = (
  task: SingleTaskModeCheckable | null | undefined
): boolean => {
  if (!task) {
    return false;
  }
  return (
    task.type === 'SceneEnrichment' &&
    task.imageExtractionToken != null &&
    task.imageExtractionToken.length > 0
  );
};
